// src/mock-data.js

const mockData = [
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200519T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MTlUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-05-19T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-05-19T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-05-19T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200520T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjBUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-05-20T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-05-20T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-05-20T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200521T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-05-21T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-05-21T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-05-21T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200522T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjJUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-05-22T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-05-22T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-05-22T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200523T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-05-23T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-05-23T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-05-23T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200525T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjVUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-05-25T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-05-25T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-05-25T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200526T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjZUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-05-26T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-05-26T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-05-26T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200527T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjdUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-05-27T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-05-27T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-05-27T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200528T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MjhUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-05-28T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-05-28T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-05-28T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200529T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA1MjlUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-05-29T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-05-29T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-05-29T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200530T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA1MzBUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-05-30T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-05-30T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-05-30T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200601T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MDFUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-01T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-01T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-01T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200602T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MDJUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-02T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-02T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-02T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200603T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MDNUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-03T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-03T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-03T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200604T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MDRUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-04T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-04T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-04T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200605T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MDVUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-05T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-05T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-05T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200606T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MDZUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-06T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-06T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-06T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200608T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MDhUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-08T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-08T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-08T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200609T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MDlUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-09T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-09T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-09T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200610T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MTBUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-10T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-10T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-10T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200611T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MTFUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-11T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-11T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-11T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200612T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MTJUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-12T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-12T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-12T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200613T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MTNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-13T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-13T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-13T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200615T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MTVUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-15T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-15T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-15T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200616T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MTZUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-16T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-16T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-16T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200617T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MTdUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-17T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-17T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-17T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200618T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MThUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-18T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-18T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-18T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200619T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MTlUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-19T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-19T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-19T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200620T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MjBUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-20T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-20T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-20T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200622T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MjJUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-22T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-22T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-22T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200623T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MjNUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-23T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-23T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-23T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200624T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MjRUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-24T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-24T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-24T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200625T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MjVUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-25T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-25T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-25T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181159875584000\"",
      "id": "3qtd6uscq4tsi6gc7nmmtpqlct_20200626T120000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=M3F0ZDZ1c2NxNHRzaTZnYzdubW10cHFsY3RfMjAyMDA2MjZUMTIwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:14:30.000Z",
      "updated": "2020-05-27T11:45:37.792Z",
      "summary": "React is Fun",
      "description": "Love HTML, CSS, and JS? Want to become a cool front-end developer? \n\nReact is one of the most popular front-end frameworks. There is a huge number of job openings for React developers in most cities. \n\nJoin us in our free React training sessions and give your career a new direction. ",
      "location": "Berlin, Germany",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-26T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-26T15:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "3qtd6uscq4tsi6gc7nmmtpqlct",
      "originalStartTime": {
        "dateTime": "2020-06-26T14:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "3qtd6uscq4tsi6gc7nmmtpqlct@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    },
    {
      "kind": "calendar#event",
      "etag": "\"3181161784712000\"",
      "id": "4eahs9ghkhrvkld72hogu9ph3e_20200627T140000Z",
      "status": "confirmed",
      "htmlLink": "https://www.google.com/calendar/event?eid=NGVhaHM5Z2hraHJ2a2xkNzJob2d1OXBoM2VfMjAyMDA2MjdUMTQwMDAwWiBmdWxsc3RhY2t3ZWJkZXZAY2FyZWVyZm91bmRyeS5jb20",
      "created": "2020-05-19T19:17:46.000Z",
      "updated": "2020-05-27T12:01:32.356Z",
      "summary": "Learn JavaScript",
      "description": "Have you wondered how you can ask Google to show you the list of the top ten must-see places in London? And how Google presents you the list? How can you submit the details of an application? Well, JavaScript is doing these. :) \n\nJavascript offers interactivity to a dull, static website. Come, learn JavaScript with us and make those beautiful websites.",
      "location": "London, UK",
      "creator": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "organizer": {
        "email": "fullstackwebdev@careerfoundry.com",
        "self": true
      },
      "start": {
        "dateTime": "2020-06-27T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "end": {
        "dateTime": "2020-06-27T17:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "recurringEventId": "4eahs9ghkhrvkld72hogu9ph3e",
      "originalStartTime": {
        "dateTime": "2020-06-27T16:00:00+02:00",
        "timeZone": "Europe/Berlin"
      },
      "iCalUID": "4eahs9ghkhrvkld72hogu9ph3e@google.com",
      "sequence": 0,
      "reminders": {
        "useDefault": true
      },
      "eventType": "default"
    }
];
  
export default mockData;